<template>
    <div class="request__window">
        <div class="request__main" v-if="request">
            <div class="request__body" >
                <app-request-tabs :request="request"></app-request-tabs>
                <!-- <app-request-search :request="request" v-show="activeTab === 'search'"></app-request-search> -->
                <app-request-contact :request="request" v-show="activeTab === 'contact'"></app-request-contact>
                <app-request-order v-if="!request.zepplinId" :request="request" v-show="activeTab === 'order'"></app-request-order>
                <app-request-zepplin v-else :request="request" v-show="activeTab === 'order'"></app-request-zepplin>
            </div>
            <div>
                <app-request-footer :activeTab="activeTab" :request="request"></app-request-footer>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapMutations, mapState, mapActions } from "vuex";
    import _ from "lodash"

    import RequestFooter from './RequestFooter.vue'
    import RequestTabs from './RequestTabs.vue'
    import RequestContact from './RequestContact.vue'
    import RequestOrder from './RequestOrder.vue'
    import RequestZepplin from './RequestZepplin.vue'

    export default {
        props: ["request"],
        components: {
            'app-request-footer': RequestFooter,
            'app-request-tabs': RequestTabs,
            'app-request-contact': RequestContact,
            'app-request-order': RequestOrder,
            'app-request-zepplin': RequestZepplin
        },
        data() {
            return {
                searchShow: false,
                searchTimeout: null,
                searchValue: null,
                searchValueStrings: [],
                searchItems: [],
                lastRequest: null,
                changeCheckInterval: null,
            }
        },
        computed: {
            ...mapState(['system']),
            ...mapState('auth', ['user']),
            activeTab() {
                return this.request ? this.request.STATE_request.activeTab : 'order'
            }
        },
        methods: {
            getTabName(tabName) {
                this.activeTab = tabName                
            }
        },
    };
</script>

<style lang="scss">
    @import "../window.scss";
    @import "./request.scss";
    .request__window {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        position: relative;
        .request__search {
            height: 50px;
            border-top: 1px solid var(--border-color--0);
            border-bottom: 1px solid var(--border-color--0);
            flex-shrink: 0;
            position: relative;
            display: flex;
            background-color: var(--bg-color--2);
            margin-bottom: 5px;
            input {
                color: #cacbce;
                background: transparent;
                border: 0 none;
                height: 50px;
                padding: 10px 8px;
                font-size: 12px;
                width: 100%;
                text-transform: uppercase;
                outline: 0;
                &:hover,
                &:focus,
                &:active {
                    background-color: var(--bg-color--3)
                }
            }
            a {
                position: absolute;
                top: 12px;
                right: 8px;
                width: 20px;
                height: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                i {
                    font-size: 18px;
                }
            }
        }
        .request__main {
            display: flex;
            flex-grow: 1;
            flex-direction: column;
            position: relative;
            .request__body {
                display: flex;
                flex-direction: column;
                flex-grow: 1;
                .request__section {
                    display: flex;
                    background-color: var(--bg-color--2);
                    flex-direction: column;
                    margin-bottom: 5px;
                    flex-shrink: 0;
                    .section__content {
                        display: none;
                        .columns {
                            flex-grow: 1;
                            display: flex;
                            flex-direction: row;
                        }
                    }
                    .section__summary {
                        height: 50px;
                        align-items: center;
                        background-color: var(--bg-color--2);
                        display: flex;
                        flex-direction: row;
                        padding: 8px;
                        cursor: pointer;
                        flex-shrink: 0;
                        h3 {
                            font-weight: 400;
                        }
                        .summary-radio {
                            margin: 0 0 0 0;
                            .v-input {
                                margin: 0;
                                padding: 0;
                                .v-radio {
                                    margin: 0;
                                }
                            }
                        }
                        &:hover {
                            background-color: var(--bg-color--3);
                        }
                    }
                    &.instruction {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    &.active {
                        display: flex;
                        flex-grow: 1;
                        flex-shrink: unset;
                        .section__content {
                            display: flex;
                            background-color: var(--bg-color--2);
                            flex-grow: 1;
                        }
                    }
                    &:last-child {
                        margin-bottom: 0;
                    }
                }
                table {
                    width: 100%;
                    text-align: left;
                    margin: 8px;
                }
                .left-side {
                    display: flex;
                    flex-direction: column;
                    flex-grow: 1;
                    div.box {
                        margin: 8px 8px 0 8px;
                        padding: 10px 12px;
                        display: flex;
                        flex-direction: column;
                        background-color: var(--bg-color--5);
                        flex-shrink: 0;
                        h3 {
                            margin-bottom: 8px;
                        }
                        &:last-child {
                            margin-bottom: 8px;
                        }
                        .client-addresses {
                            tr {
                                td {
                                    cursor: pointer;
                                    padding-top: 8px;
                                    padding-bottom: 8px;
                                    border-bottom: 1px solid var(--border-color--0);
                                }
                                &.selected {
                                    td {
                                        color: var(--font-color--primary);
                                    }
                                    &:hover {
                                        td {
                                            color: var(--font-color--primary);
                                        }
                                    }
                                }
                                &:hover {
                                    td {
                                        color: var(--font-color--6);
                                    }
                                }
                                &:first-child {
                                    td {
                                        padding-top: 0;
                                    }
                                }
                                &:last-child {
                                    td {
                                        padding-bottom: 0;
                                        margin-bottom: 0;
                                        border-bottom: 0;
                                    }
                                }
                            }
                        }
                    }
                }
                .right-side {
                    display: flex;
                    flex-direction: column;
                    width: 240px;
                    flex-shrink: 0;
                    div.box {
                        margin: 8px 8px 0 0;
                        padding: 10px 12px;
                        display: flex;
                        flex-direction: column;
                        background-color: var(--bg-color--5);
                        flex-shrink: 0;
                        .box__item {
                            display: flex;
                            flex-direction: row;
                        }
                        &:last-child {
                            margin-bottom: 8px;
                        }
                    }
                }
            }
            .request__footer {
                display: flex;
                flex-direction: row;
                height: 44px;
                flex-shrink: 0;
                background-color: var(--bg-color--6);
            }
            .request__search-result {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                background-color: var(--bg-color--2);
                .search-result__item {
                    display: flex;
                    flex-direction: row;
                    padding: 10px 8px;
                    border-bottom: 1px solid var(--border-color--0);
                    cursor: pointer;
                    transition: 0.5s all;
                    .name {
                        margin-bottom: 5px;
                    }
                    &:hover {
                        background-color: var(--bg-color--1);
                    }
                }
            }
        }
    }
</style>
